
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProductSelector from '@/components/ProductSelector.vue';
import ProductField from '@/components/ProductField.vue';
import { ProductInput, ProductData } from '@/types';
import { Weekday, Weekend, MutationType } from '@/enums';
import { t } from '@/utils';

@Component({
	components: {
		ProductSelector,
		ProductField
	}
})
export default class ProductList extends Vue {
	@Prop() questionId!: number;
	@Prop() canFinish!: boolean;
	private showSelector: boolean = false;
	private noProducts: boolean = false;

	mounted() {
		this.noProducts = this.$store.state.noProductQuestions.includes(this.questionId);
	}

	private get inputs(): ProductInput[] {
		return this.$store.state.inputs.filter((input: ProductInput) => input.questionId === this.questionId);
	}

	private openSelector(): void {
		this.showSelector = true;
	}

	private finishRegistration(): void {
		if (!this.canFinish) {
			return;
		}
		this.$emit('finish');
	}

	private onSelectorClosed(items: string[]): void {
		this.showSelector = false;
		for (const item of items) {
			this.$store.commit(MutationType.PUSH_INPUT, this.createProductInput(item));
		}
	}

	private onFieldRemoved(input: ProductInput): void {
		this.$store.commit(MutationType.REMOVE_INPUT, input);
	}

	private toggleNoProducts(): void {
		let products = this.$store.state.inputs.filter((input: ProductInput) => input.questionId === this.questionId);

		if (products.length > 0) {
			if (!confirm(t('products', 'alertDeletingProducts'))) {
				return;
			}
		}

		this.noProducts = !this.noProducts;
		if (this.noProducts) {
			for (const input of this.inputs) {
				this.$store.commit(MutationType.REMOVE_INPUT, input);
			}
		}

		if (this.noProducts) {
			this.$store.commit(MutationType.PUSH_NO_PRODUCT_QUESTION, this.questionId);
		} else {
			this.$store.commit(MutationType.REMOVE_NO_PRODUCT_QUESTION, this.questionId);
		}
	}

	private createProductInput(item: string): ProductInput {
		const data: ProductData = this.$store.state.items[item];
		return {
			questionId: this.questionId,
			data: data,
			selectedPortions: {
				[Weekday.MONDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.TUESDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.WEDNESDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.THURSDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.FRIDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.SATURDAY]: {
					index: -1,
					multiplier: 1
				},
				[Weekday.SUNDAY]: {
					index: -1,
					multiplier: 1
				}
			}
		};
	}
}
